import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'tln-recruitee-logo',
  styleUrl: './recruitee-logo.component.less',
  templateUrl: './recruitee-logo.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class RecruiteeLogoComponent {}
